// Model
import { Banner } from './../models/banner.model';
import { ApiResponse } from '../models/api-response.model';
// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// RxJS
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerHttpService {

  constructor(private http: HttpClient) { }

  getAllBanner(): Observable<Banner[]> {
    return this.http.get<ApiResponse>(`/banner`).pipe(
      map(res => res.data)
    );
  }

}
